import { usePlatformsSectionContent } from './usePlatformsSectionContent';
import { parsePlatformsEngineeredContent } from '../utils/platformsContent';

export const usePlatformsEngineeredContent = () =>
  usePlatformsSectionContent(parsePlatformsEngineeredContent);
